export default "__VITE_ASSET__7f98fe3c__"